// extracted by mini-css-extract-plugin
export default {"container":"layout_container__5BJk4","header":"layout_header__P5Ayj","content":"layout_content__+6npX"};